import React from 'react'
import { JobWizard } from 'sprockets_react/job_wizards/registries'

JobWizard.NavigationButtons = function (props) {
  const { onStepProgression, onStepRetreat, navButtonLayout, onSecondaryNavButtonClick, onModalExit } = props
  const { leftButton, rightButton } = props.buttons || {}
  const label = props.label || ''
  const layoutChooser = {
    'oneButton'      :  oneButton,
    'default'        :  twoButton,
    'threeButton'    :  threeButton,
    'leftOnlyButton' :  leftOnlyButton,
    'continueButton' :  continueButton,
    'exitButton'     :  exitButton,
    'submitButton'   : submitButton,
    'submitClosureButton' : submitClosureButton,
    'none': () => null
  }

  function submitButton() {
    return (
      <div className="row">
        <div className="col-xs-12">
          <a href="#" id="modal-nav-one-button" className="btn btn-block btn-main" style={{'whiteSpace': 'normal'}} onClick={onStepProgression}>
            {label}
          </a>
        </div>
      </div>
    )
  }

  function submitClosureButton() {
    return (
      <div className="row">
        <div className="col-xs-6">
          <a href="#" id="modal-nav-one-button" className="btn btn-block btn-main" style={{'whiteSpace': 'normal'}} onClick={onStepRetreat}>
            Back
          </a>
        </div>
        <div className="col-xs-6">
          <a href="#" id="modal-nav-one-button" className="btn btn-block btn-main" style={{'whiteSpace': 'normal'}} onClick={onStepProgression}>
            {label}
          </a>
        </div>
      </div>
    )
  }

  function oneButton() {
    return (
      <div className="row">
        <div className="col-xs-12">
          <a href="#" className="btn btn-block btn-main" onClick={onStepProgression}>
            Get Started
          </a>
        </div>
      </div>
    )
  }

  function exitButton() {
    return (
      <div className="row">
        <div className="col-xs-12">
          <a href="#" className="btn btn-block btn-main" onClick={onModalExit}>
            Exit
          </a>
        </div>
      </div>
    )
  }

  function leftOnlyButton() {
    return (
      <div className="row">
        <div className='col-sm-6 col-xs-6 pl4'>
          <a href="#" className="btn btn-block btn-clear" onClick={onStepRetreat}>
            <i className='ficon-arrow-left-shaft pr10 fs14' />
            {leftButton ? leftButton.text : 'Back'}
          </a>
        </div>
      </div>
    )
  }

  function continueButton() {
    return (
      <div className="row">
        <div className='col-sm-12 col-xs-12 pb12'>
          <a href="#" className="btn btn-block btn-secondary p12" onClick={onStepProgression}>
            {rightButton ? rightButton.text : 'Continue'}
            <i className='ficon-arrow-right-shaft pl10 fs14' />
          </a>
        </div>
      </div>
    )
  }

  function twoButton() {
    return (
      <div className="row two-button-footer">
        <div className='col-sm-6 col-xs-6 pl4 pull-right'>
          <a href="#" id="modal-nav-right-button" className={rightButton ? rightButton.className : 'btn btn-block btn-secondary'} onClick={onStepProgression}>
            {rightButton ? rightButton.text : 'Continue'}
            <i className={rightButton ? rightButton.iconClass : 'ficon-arrow-right-shaft pl10 fs14'} />
          </a>
        </div>
        <div className='col-sm-6 col-xs-6 pull-left pr4'>
          <a href="#" id="modal-nav-left-button" className="btn btn-block btn-clear" onClick={onStepRetreat}>
            <i className={leftButton ? leftButton.iconClass : 'ficon-arrow-left-shaft pr10 fs14'} />
            {leftButton ? leftButton.text : 'Back'}
          </a>
        </div>
      </div>
    )
  }

  function threeButton() {
    return (
      <div>
        <div className="three-button-footer">{twoButton()}</div>
        <div className="row">
          <div className="col-xs-12 text-center mt15">
            <a href="#" className="text-gray" onClick={onSecondaryNavButtonClick}>No Thanks</a>
          </div>
        </div>
      </div>
    )
  }
  return layoutChooser[navButtonLayout]()
}
